<template>
  <div class="pd-mb-chrome">
    <div class="pd-mb-live-price">
      <div class="pd-mb-live-price__cny">{{ host.mbLiveCnyLine }}</div>
      <div
        v-if="host.mbLiveThbLine"
        class="pd-mb-live-price__thb"
      >
        {{ host.mbLiveThbLine }}
      </div>
    </div>

    <pd-sku-picker
      class="pd-mb-sku-page"
      variant="page"
      v-bind="host.mbPickerBind"
      @pick-color="host.mbPickColor($event)"
      @pick-size="host.mbPickSize($event)"
      @select-sku="host.mbSelectFlatSku($event)"
      @set-qty="host.mbSetDraftQty($event)"
    />

    <div
      class="pd-mb-sticky"
      role="region"
    >
      <div class="pd-mb-sticky-actions">
        <router-link
          :to="{ name: 'cart' }"
          class="pd-mb-sticky-action"
        >
          <span class="pd-mb-sticky-action-ico">
            <i class="fal fa-shopping-cart" />
            <span
              v-if="cartCount > 0"
              class="pd-mb-sticky-badge"
            >{{ cartCount > 99 ? '99+' : cartCount }}</span>
          </span>
          <span class="pd-mb-sticky-action-label">{{ $t('pdCart') }}</span>
        </router-link>
        <button
          type="button"
          class="pd-mb-sticky-action"
          @click="$emit('add')"
        >
          <span class="pd-mb-sticky-action-ico">
            <i class="fal fa-cart-plus" />
          </span>
          <span class="pd-mb-sticky-action-label">{{ $t('pdAddToCartBar') }}</span>
        </button>
      </div>
      <button
        type="button"
        class="pd-mb-sticky-buy"
        @click="$emit('buy')"
      >
        <span class="pd-mb-sticky-buy-price">฿{{ thb }}</span>
        <span
          v-if="cny"
          class="pd-mb-sticky-buy-cny"
        >¥{{ cny }}</span>
      </button>
    </div>

    <pd-notice-modal :ready="host.ShowProduct === false" />

    <pd-sku-drawer
      :open="host.mbSkuDrawerOpen"
      :thumb="host.mbDrawerThumb"
      :thb="host.mbTotalThbText"
      :cny="host.mbTotalCnyText"
      :unit-thb="host.mbUnitThbText"
      :unit-cny="host.mbUnitCnyText"
      :sku-label="host.mbDrawerSkuLabel"
      :ready="host.mbSkuReady"
      :picker="host.mbPickerBind"
      :remark="host.mbDraftRemark"
      :fileimg="host.mbDraftFileimg"
      @close="host.mbCloseSkuDrawer()"
      @preview="host.mbPreviewDrawer()"
      @pick-color="host.mbPickColor($event)"
      @pick-size="host.mbPickSize($event)"
      @select-sku="host.mbSelectFlatSku($event)"
      @set-qty="host.mbSetDraftQty($event)"
      @set-remark="host.mbSetDraftRemark($event)"
      @set-file="host.mbSetDraftFile($event)"
      @clear-file="host.mbClearDraftFile()"
      @confirm="host.mbConfirmSku()"
    />
  </div>
</template>

<script>
import PdSkuPicker from './PdSkuPicker.vue'
import PdSkuDrawer from './PdSkuDrawer.vue'
import PdNoticeModal from './PdNoticeModal.vue'

export default {
  name: 'PdMobileSticky',
  components: {
    PdSkuPicker,
    PdSkuDrawer,
    PdNoticeModal,
  },
  props: {
    thb: { type: String, default: '0' },
    cny: { type: String, default: '' },
    cartCount: { type: Number, default: 0 },
  },
  computed: {
    // On some product pages this component sits inside <b-overlay>, so $parent is the
    // overlay rather than the page instance that owns the SKU state.
    host() {
      let node = this.$parent
      while (node && typeof node.mbOpenSkuDrawer !== 'function') {
        node = node.$parent
      }
      return node || this.$vnode.context || this.$parent
    },
  },
}
</script>
